module.exports = __webpack_public_path__ + "855ce262c9f1c8352070ccf73749cacb.svg";